import React from "react";
import "../../App.css";
import Cards from "../Cards";

function Pethree() {
  return (
    <>
      <div className="pe03">
        <img src="images/img-15.jpg" width="100%" height="auto" alt="" />
      </div>
      <Cards />
    </>
  );
}

export default Pethree;
